import React, { useState, useEffect } from 'react';
import logo from '../logo_blade.png';
import { db } from '../services/firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

const DIAS_SEMANA = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

function temHorarioHoje(barbeiro) {
  const agora = new Date();
  const agoraMins = agora.getHours() * 60 + agora.getMinutes();
  const diaSemana = DIAS_SEMANA[agora.getDay()];
  const hp = barbeiro?.horariosPorDia;
  if (hp) {
    const periodos = hp[diaSemana];
    if (!periodos || periodos.length === 0) return false;
    return periodos.some(p => {
      const [fh, fm] = p.fim.split(':').map(Number);
      return fh * 60 + fm > agoraMins;
    });
  }
  const diasTrabalho = barbeiro?.diasTrabalho || [];
  if (!diasTrabalho.includes(diaSemana)) return false;
  const [fh, fm] = (barbeiro?.horaFim || '19:00').split(':').map(Number);
  return fh * 60 + fm > agoraMins;
}

function Estrelas({ nota, tamanho = 12 }) {
  return (
    <span>
      {[1, 2, 3, 4, 5].map(n => (
        <span key={n} style={{ fontSize: tamanho, color: n <= Math.round(nota) ? '#c9a84c' : '#2a2a2a' }}>★</span>
      ))}
    </span>
  );
}

function Barbeiros({ barbearia, editando, onVoltar, onEscolher, onInicio }) {
  const barbeiros = (barbearia?.barbeiros || []).filter(b => !b.oculto);
  const [avaliacoes, setAvaliacoes] = useState([]);
  const [modalReviews, setModalReviews] = useState(null);
  const [perfilAberto, setPerfilAberto] = useState(false);
  const [fotoAmpliada, setFotoAmpliada] = useState(null);
  const [favoritoId, setFavoritoId] = useState(() => localStorage.getItem('blade_favorito') || null);

  function getEnderecoFormatado(b) {
    if (b?.endereco?.rua) {
      return `${b.endereco.rua}, ${b.endereco.numero} — ${b.endereco.bairro}, ${b.endereco.cidade}`;
    }
    return b?.endereco?.completo || '';
  }
  function getMapsUrl(b) {
    return `https://maps.google.com/?q=${encodeURIComponent(b?.endereco?.completo || b?.nome || '')}`;
  }
  function getWazeUrl(b) {
    return `https://waze.com/ul?q=${encodeURIComponent(b?.endereco?.completo || b?.nome || '')}`;
  }
  // Badges de promoção — mesmo formato da listagem de barbearias
  function renderPromoBadges(b) {
    const p = b?.promocao;
    if (!p) return null;
    const nomesDias = ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'];
    const badgeOuro = { display: 'inline-block', fontSize: '10px', color: '#c9a84c', backgroundColor: '#2a1a05', border: '0.5px solid #c9a84c', borderRadius: '10px', padding: '2px 8px', marginBottom: '4px', marginRight: '4px' };
    const badgeVerde = { display: 'inline-block', fontSize: '10px', color: '#7bc47b', backgroundColor: '#141f14', border: '0.5px solid #2d4a2d', borderRadius: '10px', padding: '2px 8px', marginBottom: '4px', marginRight: '4px' };
    const isNovoFormato = p.simples !== undefined || p.dias !== undefined || p.fidelidade !== undefined;
    if (isNovoFormato) {
      const badges = [];
      if (p.fidelidade?.ativa) {
        const meta = p.fidelidade.fidelidadeMeta || 10;
        badges.push(<div key="fid" style={badgeVerde}>⭐ {p.fidelidade.texto || `Ganhe 1 grátis a cada ${meta} visitas`}</div>);
      }
      if (p.dias?.ativa && (p.dias.diasSemana || []).length > 0) {
        const diasStr = p.dias.diasSemana.map(i => nomesDias[i]).join(', ');
        badges.push(<div key="dias" style={badgeOuro}>🏷️ {p.dias.texto || `${p.dias.desconto}% off — ${diasStr}`}</div>);
      }
      if (p.simples?.ativa && p.simples.desconto > 0) {
        badges.push(<div key="sim" style={badgeOuro}>🏷️ {p.simples.texto || `${p.simples.desconto}% off`}</div>);
      }
      return badges.length > 0 ? <div>{badges}</div> : null;
    }
    if (!p.ativa) return null;
    if (p.tipo === 'fidelidade') {
      const meta = p.fidelidadeMeta || 10;
      return <div style={badgeVerde}>⭐ {p.texto || `Ganhe 1 grátis a cada ${meta} visitas`}</div>;
    }
    if (p.tipo === 'dias' && (p.diasSemana || []).length > 0) {
      const diasStr = p.diasSemana.map(i => nomesDias[i]).join(', ');
      return <div style={badgeOuro}>🏷️ {p.texto || `${p.desconto}% off — ${diasStr}`}</div>;
    }
    return <div style={badgeOuro}>🏷️ {p.texto || (p.desconto > 0 ? `${p.desconto}% off` : 'Promoção ativa!')}</div>;
  }

  useEffect(() => {
    const bid = barbearia?.id || barbearia?.uid;
    if (!bid) return;
    getDocs(query(
      collection(db, 'avaliacoes'),
      where('barbeariaId', '==', bid)
    )).then(snap => {
      setAvaliacoes(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    }).catch(() => {});
  }, [barbearia]);

  function toggleFavorito(e) {
    e.stopPropagation();
    const bid = barbearia?.id || barbearia?.uid;
    if (favoritoId === bid) {
      localStorage.removeItem('blade_favorito');
      setFavoritoId(null);
    } else {
      localStorage.setItem('blade_favorito', bid);
      setFavoritoId(bid);
    }
  }

  function statsBarb(nome) {
    const revs = avaliacoes.filter(a => a.barbeiroNome === nome);
    if (revs.length === 0) return null;
    const media = revs.reduce((s, a) => s + (a.estrelas || 0), 0) / revs.length;
    return { media: Math.round(media * 10) / 10, total: revs.length };
  }

  function reviewsBarb(nome) {
    return avaliacoes
      .filter(a => a.barbeiroNome === nome)
      .sort((a, b) => (b.criadoEm || '').localeCompare(a.criadoEm || ''));
  }

  const bid = barbearia?.id || barbearia?.uid;
  const isFavorita = favoritoId === bid;
  const fotosRecinto = barbearia?.fotosRecinto || [];

  return (
    <div style={{ backgroundColor: '#111111', minHeight: '100vh', fontFamily: 'Arial, sans-serif', color: '#e8e8e8' }}>

      {/* Modal de foto ampliada */}
      {fotoAmpliada && (
        <div style={{
          position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.92)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px'
        }} onClick={() => setFotoAmpliada(null)}>
          <img src={fotoAmpliada} alt="barbeiro"
            style={{ maxWidth: '90%', maxHeight: '80vh', borderRadius: '16px', objectFit: 'contain' }}
            onClick={e => e.stopPropagation()} />
        </div>
      )}

      {/* Modal de avaliações */}
      {modalReviews && (
        <div style={{
          position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.88)',
          display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 999
        }} onClick={() => setModalReviews(null)}>
          <div style={{
            width: '100%', maxWidth: '480px', backgroundColor: '#181818',
            borderRadius: '20px 20px 0 0', padding: '24px 20px 36px',
            border: '0.5px solid #252525', maxHeight: '70vh', overflowY: 'auto'
          }} onClick={e => e.stopPropagation()}>
            <div style={{ width: '40px', height: '4px', backgroundColor: '#333', borderRadius: '2px', margin: '0 auto 20px' }} />
            <div style={{ fontSize: '15px', fontWeight: '700', color: '#e8e8e8', marginBottom: '4px' }}>
              Avaliações · {modalReviews}
            </div>
            {(() => {
              const revs = reviewsBarb(modalReviews);
              const stats = statsBarb(modalReviews);
              if (revs.length === 0) return <p style={{ color: '#8f8f8f', fontSize: '13px', marginTop: '16px' }}>Nenhuma avaliação ainda.</p>;
              return (
                <>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
                    <Estrelas nota={stats.media} tamanho={18} />
                    <span style={{ fontSize: '14px', color: '#c9a84c', fontWeight: '700' }}>{stats.media.toFixed(1)}</span>
                    <span style={{ fontSize: '11px', color: '#8f8f8f' }}>({stats.total} avaliação{stats.total !== 1 ? 'ões' : ''})</span>
                  </div>
                  {revs.map((r, i) => (
                    <div key={i} style={{ padding: '12px 0', borderBottom: i < revs.length - 1 ? '0.5px solid #1e1e1e' : 'none' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' }}>
                        <span style={{ fontSize: '12px', color: '#ccc', fontWeight: '600' }}>{r.clienteNome || 'Cliente'}</span>
                        <Estrelas nota={r.estrelas} tamanho={12} />
                      </div>
                      {r.comentario && <p style={{ fontSize: '12px', color: '#aeaeae', margin: 0, lineHeight: '1.5' }}>{r.comentario}</p>}
                      <p style={{ fontSize: '10px', color: '#7d7d7d', margin: '4px 0 0' }}>
                        {r.criadoEm ? new Date(r.criadoEm).toLocaleDateString('pt-BR') : ''}
                      </p>
                    </div>
                  ))}
                </>
              );
            })()}
          </div>
        </div>
      )}

      {/* Cabeçalho fixo */}
      <div style={{ padding: '20px', borderBottom: '1px solid #1a1a1a', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span onClick={onVoltar} style={{ fontSize: '22px', color: '#b6b6b6', cursor: 'pointer' }}>‹</span>
        <img src={logo} alt="BLADE" style={{ height: '36px', cursor: 'pointer' }} onClick={onInicio} />
        <span style={{ width: '22px' }} />
      </div>

      {/* Header da barbearia — recolhível */}
      <div
        onClick={() => setPerfilAberto(v => !v)}
        style={{
          margin: '12px 20px', backgroundColor: '#181818',
          border: perfilAberto ? '0.5px solid #3d6b3d' : '0.5px solid #252525',
          borderRadius: '14px', overflow: 'hidden', cursor: 'pointer',
          transition: 'border-color 0.2s',
        }}
      >
        {/* Linha sempre visível */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 14px' }}>
          <div style={{ width: '52px', height: '52px', borderRadius: '10px', overflow: 'hidden', flexShrink: 0, backgroundColor: '#2a2a2a' }}>
            {barbearia?.foto
              ? <img src={barbearia.foto} alt={barbearia.nome} style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={e => e.target.style.display = 'none'} />
              : <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px' }}>✂️</div>
            }
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: '700', fontSize: '15px', color: '#e8e8e8' }}>{barbearia?.nome || 'Barbearia'}</div>
            <div style={{ fontSize: '11px', color: '#8f8f8f', marginTop: '2px' }}>
              {perfilAberto ? 'Toque para recolher' : 'Toque para ver fotos e descrição'}
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0 }}>
            <button
              onClick={toggleFavorito}
              style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px', padding: 0, lineHeight: 1 }}
            >
              {isFavorita ? '⭐' : '☆'}
            </button>
            <span style={{ color: '#7d7d7d', fontSize: '16px', transition: 'transform 0.2s', display: 'inline-block', transform: perfilAberto ? 'rotate(90deg)' : 'rotate(0deg)' }}>›</span>
          </div>
        </div>

        {/* Conteúdo expandido */}
        {perfilAberto && (
          <div style={{ borderTop: '0.5px solid #252525' }}>
            {/* Fotos do recinto */}
            {fotosRecinto.length > 0 && (
              <div style={{ padding: '12px 14px 0' }}>
                <div style={{ display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '4px' }}>
                  {fotosRecinto.map((url, i) => (
                    <img key={i} src={url} alt={`recinto ${i + 1}`}
                      style={{ width: '110px', height: '80px', objectFit: 'cover', borderRadius: '8px', flexShrink: 0 }}
                      onError={e => e.target.style.display = 'none'} />
                  ))}
                </div>
              </div>
            )}

            {/* Descrição */}
            {barbearia?.descricao && (
              <div style={{ padding: '12px 14px 0', fontSize: '13px', color: '#aeaeae', lineHeight: '1.6' }}>
                {barbearia.descricao}
              </div>
            )}

            {/* Endereço + Maps/Waze */}
            {getEnderecoFormatado(barbearia) && (
              <div style={{ padding: '12px 14px 0' }} onClick={e => e.stopPropagation()}>
                <div style={{ fontSize: '12px', color: '#aeaeae', marginBottom: '6px' }}>📍 {getEnderecoFormatado(barbearia)}</div>
                <div style={{ display: 'flex', gap: '6px' }}>
                  <a href={getMapsUrl(barbearia)} target="_blank" rel="noreferrer"
                    style={{ backgroundColor: '#1a1a2a', color: '#7bc4ff', border: '0.5px solid #2a2a4a', borderRadius: '16px', padding: '3px 10px', fontSize: '10px', textDecoration: 'none' }}>🗺 Maps</a>
                  <a href={getWazeUrl(barbearia)} target="_blank" rel="noreferrer"
                    style={{ backgroundColor: '#1a1a2a', color: '#7bc4ff', border: '0.5px solid #2a2a4a', borderRadius: '16px', padding: '3px 10px', fontSize: '10px', textDecoration: 'none' }}>🚗 Waze</a>
                </div>
              </div>
            )}

            {/* Descontos / promoções */}
            {renderPromoBadges(barbearia) && (
              <div style={{ padding: '12px 14px 0' }}>
                {renderPromoBadges(barbearia)}
              </div>
            )}

            {/* Serviços e preços */}
            {(barbearia?.servicos || []).length > 0 && (
              <div style={{ padding: '12px 14px 0' }}>
                <div style={{ fontSize: '10px', color: '#aeaeae', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>Serviços</div>
                {barbearia.servicos.map((s, i) => (
                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 0', borderBottom: i < barbearia.servicos.length - 1 ? '0.5px solid #1e1e1e' : 'none' }}>
                    <div>
                      <div style={{ fontSize: '13px', color: '#e8e8e8' }}>{s.nome}</div>
                      {s.duracao && <div style={{ fontSize: '10px', color: '#8f8f8f' }}>{s.duracao}{/\d$/.test(s.duracao) ? ' min' : ''}</div>}
                    </div>
                    <span style={{ fontSize: '13px', color: '#7bc47b', fontWeight: '600' }}>{s.preco}</span>
                  </div>
                ))}
              </div>
            )}

            <div style={{ height: '12px' }} />

            {!barbearia?.descricao && fotosRecinto.length === 0 && !getEnderecoFormatado(barbearia) && (barbearia?.servicos || []).length === 0 && (
              <div style={{ padding: '12px 14px', fontSize: '12px', color: '#7d7d7d' }}>
                Sem fotos ou descrição cadastradas.
              </div>
            )}
          </div>
        )}
      </div>

      {/* Banner de edição */}
      {editando && (
        <div style={{ margin: '0 20px 10px', backgroundColor: '#1a1508', border: '0.5px solid #c9a84c', borderRadius: '12px', padding: '10px 14px' }}>
          <div style={{ fontSize: '12px', color: '#c9a84c', fontWeight: '700', marginBottom: '2px' }}>✏️ Editando agendamento</div>
          <div style={{ fontSize: '11px', color: '#b6b6b6', lineHeight: '1.5' }}>
            Escolha o barbeiro (pode manter o mesmo) — depois você ajusta horário e serviço. O agendamento atual só é trocado ao confirmar.
          </div>
        </div>
      )}

      {/* Título da lista */}
      <div style={{ padding: '4px 20px 10px' }}>
        <h1 style={{ fontSize: '20px', fontWeight: '700', margin: '0 0 2px 0' }}>{editando ? 'Escolha o barbeiro' : 'Escolha seu barbeiro'}</h1>
      </div>

      {barbeiros.length === 0 && (
        <div style={{ textAlign: 'center', padding: '40px 20px', color: '#8f8f8f', fontSize: '13px' }}>
          Nenhum barbeiro cadastrado.
        </div>
      )}

      {/* Cards dos barbeiros */}
      {barbeiros.map((b, idx) => {
        const stats = statsBarb(b.nome);
        return (
          <div key={idx}
            onClick={() => onEscolher(b)}
            style={{
              margin: '0 20px 10px', backgroundColor: '#1a1a1a',
              border: '1px solid #252525', borderRadius: '12px', padding: '12px', cursor: 'pointer'
            }}>
            <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
              {/* Avatar — toque amplia a foto */}
              <div
                onClick={(e) => { if (b.foto) { e.stopPropagation(); setFotoAmpliada(b.foto); } }}
                style={{
                width: '52px', height: '52px', backgroundColor: '#2a2a2a',
                borderRadius: '50%', flexShrink: 0, overflow: 'hidden',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: b.foto ? 'zoom-in' : 'pointer'
              }}>
                {b.foto
                  ? <img src={b.foto} alt={b.nome} style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={e => e.target.style.display = 'none'} />
                  : (
                    <svg width="26" height="26" viewBox="0 0 36 36" fill="none">
                      <path d="M18 4C14 4 11 7 11 11C11 15 14 18 18 18C22 18 25 15 25 11C25 7 22 4 18 4Z" fill="#3a3a3a" />
                      <path d="M8 8L12 14M28 8L24 14" stroke="#7bc47b" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                  )
                }
              </div>

              {/* Info */}
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '4px' }}>{b.nome}</div>

                {stats ? (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginBottom: '4px' }}>
                    <Estrelas nota={stats.media} tamanho={13} />
                    <span style={{ fontSize: '11px', color: '#c9a84c', fontWeight: '600' }}>{stats.media.toFixed(1)}</span>
                    <span style={{ fontSize: '10px', color: '#8f8f8f' }}>({stats.total})</span>
                  </div>
                ) : (
                  <div style={{ fontSize: '10px', color: '#7d7d7d', marginBottom: '4px' }}>Sem avaliações ainda</div>
                )}

                {!temHorarioHoje(b) && (
                  <div style={{ display: 'inline-block', fontSize: '10px', color: '#c9a84c', backgroundColor: '#2a2010', border: '0.5px solid #3a3010', borderRadius: '10px', padding: '2px 8px', marginTop: '2px' }}>
                    Sem horário hoje
                  </div>
                )}
              </div>
            </div>

            {/* Botões */}
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <span style={{ flex: 1, fontSize: '11px', color: '#7bc47b', fontWeight: '600' }}>Toque para ver horários ›</span>
              {stats && (
                <button onClick={(e) => { e.stopPropagation(); setModalReviews(b.nome); }} style={{
                  backgroundColor: 'transparent', color: '#c9a84c',
                  border: '0.5px solid #3a3010', borderRadius: '16px',
                  padding: '5px 12px', fontSize: '11px', cursor: 'pointer',
                  fontFamily: 'Arial, sans-serif'
                }}>Ver avaliações</button>
              )}
            </div>
          </div>
        );
      })}

      <div style={{ height: '32px' }} />
    </div>
  );
}

export default Barbeiros;
